export default class CollectionHelper {
  public static sortByName<TItem extends { name: string }>(items: TItem[]): TItem[] {
    return items.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
  }

  public static groupBy<Key, Value>(items: Value[], keyGetter: (value: Value) => Key): Map<Key, Value[]> {
    const map = new Map<Key, Value[]>();

    items.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);

      if (!collection) {
        map.set(key, [item]);
      }
      else {
        collection.push(item);
      }
    });

    return map;
  }

  public static sortBy<TItem>(items: TItem[], getKey: (any: TItem) => any) {
    return items.sort((a, b) => {
      const keyA = getKey(a);
      const keyB = getKey(b);

      return keyA > keyB ? 1 : -1;
    });
  }
}
